  $(document).ready(function(){
      $(".ProductRegionalzipCode .ZipPostalCode").click(function(){
         var check_zipcode = localStorage.getItem("zipcode");
         if(!check_zipcode){
          getLocation();
         }
    });
       $(".redioButton").click(function(){
     var check_store = $(this).attr("data-value");
      var mainClass = $(this).attr("data-class");
      console.log("Class",mainClass);
    // if(check_store == "US"){
    //   $("."+mainClass+" .usaCountry:radio").trigger("click");
    //     $("."+mainClass+" .regionalInputLbabel").text("Enter Zip code"); 
    //   $("."+mainClass+" .regional_input").attr("placeholder","Zip Code*");
    // }else{
    //    $("."+mainClass+" .caCountry:radio").trigger("click");
    //    $("."+mainClass+" .regionalInputLbabel").text("Enter Postal code"); 
    //   $("."+mainClass+" .regional_input").attr("placeholder","Postal Code*");
    // }
      
      // alert(check_store,check_class);
    });
  // $(".regionalMainPopup,.back-drop").addClass("hide");

        var timeOut = 2000;
    if(main_page_url.indexOf("/pages/cart")!=-1){
      timeOut = 6000;
    }
setTimeout(function(){
 var zipcode = localStorage.getItem("zipcode");

  var zipcodePopup = localStorage.getItem("zipcodePopup");
  if(zipcode == "" || zipcode === null ){
    // if(zipcodePopup == "" || zipcodePopup === null ){
    //       
    // }
   // $(".regionalMainPopup,.back-drop").removeClass("hide");  
    $(".regionalMainPopup .regionalSubmitBtn  ").attr("data-class","regionalMainPopup");
    $(".regionalMainPopup .redioButton  ").attr("data-class","regionalMainPopup");
    //getLocation(); 
   
  }else{
    console.log("zipcode",zipcode);
      $(".RegionalHeaderCode .addReplaceZipcode").text(zipcode);   
    $(".collectionRegionalzipCode .addReplaceZipcode").text(zipcode);
     $(".ProductRegionalzipCode .addReplaceZipcode").text(zipcode);
    }
  console.log("timeout is  ", timeOut,main_page_url.indexOf("/pages/cart"));
},timeOut);

   var allowGeoRecall = true;
       var countLocationAttempts = 0; 
  function getLocation() {   
        console.log('getLocation was called') 
        if(navigator.geolocation) {
            // navigator.geolocation.getCurrentPosition(showPosition, positionError);
        } else {
            hideLoadingDiv()
            console.log('Geolocation is not supported by this device')
        }
    }

    function positionError() {    
        console.log('Geolocation is not enabled. Please enable to use this feature')
            
         if(allowGeoRecall && countLocationAttempts < 5) {
             countLocationAttempts += 1;
             getLocation();
         }
     }

    function showPosition(position){
      // return false;
       var latitude = position.coords.latitude; 
       var longitude = position.coords.longitude; 
       var location = latitude+","+longitude;
      //CODE FOR POSITIONSTACK
    const settings = {
    url: 'https://api.positionstack.com/v1/reverse',
    data: {
      access_key: '4b60122760f140445017a6d7d883f4f2',
       query: location,
      limit: 10
    }
    };
      //CODE FOR TRUWAY
 //     const settings = {
	// "crossDomain": true,
 //    url: 'https://trueway-geocoding.p.rapidapi.com/ReverseGeocode',
 //    data: {
 //       location: location
 //    },
 //    headers: {
 //      "X-RapidAPI-Key": "ab31b279d6mshc0e6f983f1a6b94p106c9fjsn65b34f26a706",
 //      "X-RapidAPI-Host": "trueway-geocoding.p.rapidapi.com"
 //    	}
 //    };

$.ajax(settings).done(function (response) {

 
  // var postal_code = response.data[0].postal_code;
  let object_with_postalcode = {postal_code:null};
  let address_with_nearest_distance = {distance:1,address:"",post_object:{batch:[]}};
  object_with_postalcode = response.data.find(object=>{   //response.results for TRUWAY
    if(object.postal_code!==null){
        return object.postal_code;
    }
    //CODE FOR POSITIONSTACK
    if(object.distance < address_with_nearest_distance.distance){
      address_with_nearest_distance.distance = object.distance;
      address_with_nearest_distance.address = object.label;
    }
    address_with_nearest_distance.post_object.batch.push({query:object.name,country:"CA",region:object.label})
  })
console.log("details ",address_with_nearest_distance)
  if(!object_with_postalcode){
    //CODE FOR POSITIONSTACK
    var post_json_data = JSON.stringify({"batch":address_with_nearest_distance.post_object.batch});
    const forward_geocode_settings = {
      url: 'https://api.positionstack.com/v1/forward?access_key=4b60122760f140445017a6d7d883f4f2',
      data: {query:address_with_nearest_distance.address},
    };
    $.ajax(forward_geocode_settings).done(function (response) {
      console.log("details forward response", response)
        object_with_postalcode = response.data.find(object=>{
            if(object.postal_code!==null){
                return object.postal_code;
            }
          })
    });
  }
  if (object_with_postalcode){
   $(".regional_input").val(object_with_postalcode.postal_code);
    // $(".regionalMainPopup,.back-drop").removeClass("hide");  
    $(".regionalMainPopup .regionalSubmitBtn  ").attr("data-class","regionalMainPopup");
    $(".regionalMainPopup .redioButton  ").attr("data-class","regionalMainPopup");
    $(".regionalCloseButton").attr("data-value","onloadpop");
  }else{
  }
}).fail(function(jqXHR, textStatus){
});
        allowGeoRecall = false;
    }

 
      

});

   

